import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FlowchartPaper_History_Interface } from 'src/app/Interface/FlowchartPaper_History_Interface';
import { FlowchartPaper_Interface } from 'src/app/Interface/FlowchartPaper_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FlowcharPaperService {

  constructor(private http:HttpClient) { }

  Read_Inbox(Token:String,
    number:string,
    FormId:number):Observable<Array<FlowchartPaper_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/FlowchartPaper/Read_Inbox?token="+Token +
    "&number="+number + 
    "&FormId="+FormId).pipe(
      map(data=>{
        return data as Array<FlowchartPaper_Interface>
      })
    )
  }

  Read_archive(Token:String,
    number:string,
    startDate:string,
    endDate:string,
    submitPeriod:number,
    FormId:number):Observable<Array<FlowchartPaper_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/FlowchartPaper/Read_archive?token="+Token +
    "&number="+number + 
    "&startDate="+startDate + 
    "&endDate="+endDate + 
    "&submitPeriod="+submitPeriod + 
    "&FormId="+FormId).pipe(
      map(data=>{
        return data as Array<FlowchartPaper_Interface>
      })
    )
  }

  Inbox_Action(Token:String,
    Dsc:string,
    MakerId:number,
    id:number):Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/FlowchartPaper/Inbox_Action?token="+Token +
    "&Dsc="+Dsc + 
    "&MakerId="+MakerId + 
    "&id="+id ).pipe(
      map(data=>{
        return data as any
      })
    )
  }




  History_WorkFlow(Token:String,id:number):Observable<Array<FlowchartPaper_History_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/FlowchartPaper/History_WorkFlow?token="+Token +
    "&id="+id ).pipe(
      map(data=>{
        return data as Array<FlowchartPaper_History_Interface>
      })
    )
  }

}
